import React, { useId } from "react";
import Icon from "../icons/Icon";
import { useDialogChrome } from "../../hooks/useDialogChrome";

// Painel ancorado à direita, para leitura longa: o cabeçalho fica parado e só
// o corpo rola, então o ✕ continua ao alcance no fim de uma lista comprida —
// é ele que dispensa o "Fechar" de rodapé que o modal tem.
function Drawer({ title, subtitle, onClose, children }) {
  const titleId = useId();
  const { dialogRef, handleKeyDown, handleOverlayPress } = useDialogChrome(onClose);

  return (
    <div className="overlay overlay-right" onMouseDown={handleOverlayPress}>
      <aside
        className="drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        ref={dialogRef}
        onKeyDown={handleKeyDown}
      >
        <div className="drawer-head">
          <div className="drawer-heading">
            <h2 className="drawer-title" id={titleId}>
              {title}
            </h2>
            {subtitle && <p className="drawer-subtitle">{subtitle}</p>}
          </div>

          <button className="dialog-close" type="button" aria-label="Fechar" onClick={onClose}>
            <Icon name="x" strokeWidth={2.5} />
          </button>
        </div>

        <div className="drawer-body">{children}</div>
      </aside>
    </div>
  );
}

export default Drawer;
